<ion-content class="modal-options ion-padding">
  <div class="option-row" (click)="onWatchTicket()">
    <img src="assets/icons/ticket-icon.svg" class="option-icon" />
    <span>{{
      "tickets-sold.ticket-options-modal.watch-ticket" | translate
    }}</span>
  </div>

  <div class="option-row" (click)="onSendTicket()">
    <img src="assets/icons/share-icon.svg" class="option-icon" />
    <span>{{
      "tickets-sold.ticket-options-modal.send-ticket" | translate
    }}</span>
  </div>

  @if (!ticket?.ecommerce) {
  <div class="option-row" (click)="onEditQuote()">
    <ion-icon name="pencil-outline" class="option-icon edit-icon" />
    <span>{{
      "tickets-sold.ticket-options-modal.edit-quote" | translate
    }}</span>
  </div>
  <div class="option-row danger" (click)="onDelete()">
    <ion-icon name="trash-outline" class="option-icon danger-icon" />
    <span>{{
      "tickets-sold.ticket-options-modal.delete-ticket" | translate
    }}</span>
  </div>
  }
</ion-content>
